import React from "react";
import { formFieldVerticalGap, inputMarginBottom, modalPaddingExtraSmall } from "@iventis/styles/src/atomic-rules";
import { styled, darkScrollbarMixin, muiInputFormsCSS } from "@iventis/styles";
import { Theme } from "@emotion/react";

interface PopoverContainerProps {
    testId: string;
    children: React.ReactNode;
    className?: string;
}
const mapObjectDetailsHeight = "500px";

export const PopoverContainer: React.FC<PopoverContainerProps> = ({ testId, children, className }) => (
    <StyledPopup className={className} data-testid={testId}>
        {children}
    </StyledPopup>
);

const StyledPopup = styled.div`
    display: flex;
    flex-direction: column;
    max-height: 406.328px;
    .minimise-objectDetails-transition {
        overflow: hidden;
        position: relative;
        transition: all 0.2s ease-in-out;

        &.enter {
            max-height: 0px;
        }

        &.exit,
        &.enter-active {
            max-height: ${mapObjectDetailsHeight};
        }

        &.exit-active {
            max-height: 0px;
        }
    }

    .header {
        border-bottom: 1px solid ${({ theme }: { theme: Theme }) => theme.otherColors.separatorLight};
        padding: 5px 0 5px ${modalPaddingExtraSmall};
        display: flex;
        flex: 0 0;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        box-sizing: border-box;
        .title {
            display: flex;
            align-items: center;
            width: 90%;
            h6 {
                margin: 0 7px;
                white-space: nowrap;
            }
        }
        .minimise {
            padding: 1rem;
            width: 10%;
            display: flex;
            justify-content: flex-end;
            &:hover {
                color: ${({ theme }: { theme: Theme }) => theme.primaryColors.focusAccent};
            }
        }
    }

    .objectDetails-content {
        overflow-y: scroll;
        ${muiInputFormsCSS}
        height: 300px;
        color: ${({ theme }: { theme: Theme }) => theme.typographyColors.blank};
        .MuiInputBase-root,
        .Mui-Datepicker,
        textarea {
            width: 100%;
            margin-bottom: ${inputMarginBottom};
        }

        flex-grow: 1;
        padding: 15px;
        box-sizing: border-box;
        /*  For some reason (perhaps MUI) when the style dialog is opened, it applies overflow: initial to the element this class is applied to. !important used to override this */
        overflow-y: auto !important;
        .dropdown-root {
            background-color: white;
            color: black;
            border: none;
        }

        ${(props) => darkScrollbarMixin(props.theme)}
    }

    .bottom-interactions {
        flex: 0 0;
        height: 50px;
        width: 100%;
        border-top: 1px solid ${({ theme }: { theme: Theme }) => theme.otherColors.separatorLight};
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-content: center;
        box-sizing: border-box;
        padding: ${modalPaddingExtraSmall};
    }
    .edit-data-fields {
        p {
            text-decoration: underline;
        }
    }
    .bottom-save-display {
        display: flex;
        align-content: center;
        justify-content: flex-end;
        flex-grow: 1;
        flex-direction: row;
    }

    .file-upload-input {
        flex: 1 1;
    }

    .file-upload-button {
        flex-shrink: 0;
        min-width: 120px;
    }

    .file-upload-container {
        margin-bottom: ${formFieldVerticalGap};
    }
`;
